export default __webpack_public_path__ + "static/media/support-group-hub.b1fa9b84.png";